var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.961 0H5.039C2.268 0 0 2.268 0 5.04V24.96C0 27.732 2.268 30 5.04 30H24.96C27.732 30 30 27.732 30 24.961V5.039C30 2.268 27.732 0 24.961 0z",
    fill: "#00ACED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.997 8.898a8.493 8.493 0 0 1-2.056 2.088 11.3 11.3 0 0 1-.47 3.768 11.674 11.674 0 0 1-1.465 3.106 12.251 12.251 0 0 1-2.34 2.633c-.905.762-1.997 1.37-3.275 1.825-1.277.455-2.643.682-4.097.682C9 23 6.904 22.396 5 21.187c.296.033.625.05.99.05 1.903 0 3.599-.575 5.088-1.725a4.043 4.043 0 0 1-2.386-.807 3.946 3.946 0 0 1-1.447-1.994c.279.042.537.063.774.063.364 0 .724-.046 1.079-.138a4.045 4.045 0 0 1-2.354-1.394 3.864 3.864 0 0 1-.932-2.568v-.05a4.103 4.103 0 0 0 1.853.513A4.05 4.05 0 0 1 6.333 11.7a3.904 3.904 0 0 1-.495-1.925c0-.734.186-1.413.559-2.037a11.575 11.575 0 0 0 3.737 2.98c1.468.746 3.04 1.16 4.713 1.244a4.457 4.457 0 0 1-.1-.925c0-1.117.4-2.069 1.198-2.856.8-.787 1.766-1.181 2.9-1.181 1.184 0 2.182.425 2.994 1.275.923-.175 1.79-.5 2.602-.974-.313.958-.913 1.7-1.8 2.226A8.233 8.233 0 0 0 25 8.9l-.003-.003z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLink);
export default __webpack_public_path__ + "static/media/twitterLink.8a556d7ae62169abaced0762f96827b7.svg";
export { ForwardRef as ReactComponent };